// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_a7-0";
export var optionCard = "_a7-1";